import { useEffect, useState } from 'react';

import { Button } from '@/components/Button';
import Input from '@/components/Input';
import MailDialog from './MailDialog';

interface CandidateMailTemplateSaveModalProps {
  open: boolean;
  initialName: string;
  onClose: () => void;
  onConfirm: (name: string) => void | Promise<void>;
  isSaving?: boolean;
}

export default function CandidateMailTemplateSaveModal({
  open,
  initialName,
  onClose,
  onConfirm,
  isSaving = false,
}: CandidateMailTemplateSaveModalProps) {
  const [name, setName] = useState(initialName);

  useEffect(() => {
    if (open) setName(initialName);
  }, [initialName, open]);

  const isConfirmDisabled = isSaving || name.trim().length === 0;

  const handleConfirm = async () => {
    if (isConfirmDisabled) return;
    await onConfirm(name.trim());
  };

  return (
    <MailDialog
      open={open}
      onClose={onClose}
      title="テンプレートを保存する"
      widthClassName="w-[448px]"
      preventClose={isSaving}
      footer={
        <>
          <Button type="button" color="secondary" size="md" onClick={onClose} disabled={isSaving}>
            保存しない
          </Button>
          <Button
            type="button"
            color="primary"
            size="md"
            onClick={() => void handleConfirm()}
            disabled={isConfirmDisabled}
          >
            保存
          </Button>
        </>
      }
    >
      <div className="flex flex-col gap-xs">
        <label htmlFor="candidate-mail-template-save-name" className="text-heading-xxs text-main">
          テンプレート名
        </label>
        <Input
          id="candidate-mail-template-save-name"
          className="w-full"
          placeholder="入力してください"
          value={name}
          onChange={(event) => setName(event.target.value)}
          disabled={isSaving}
        />
      </div>
    </MailDialog>
  );
}
